import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import RefreshIcon from '@material-ui/icons/Refresh';
import lng from '../../misc/lng';

const {chiLng} = lng;

const useStyles = makeStyles(() => ({
    root: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        overflow: 'hidden',
        backgroundColor: '#f5f5f5',
        padding: '20px',
    },
    topPanel: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        color: 'white',
        backgroundColor: '#666666',
        height: '65px',
        width: '100%',
        position: 'fixed',
        top: 0,
        left: 0,
        zIndex: 1000,
    },
    content: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        textAlign: 'center',
        maxWidth: '400px',
        padding: '20px',
        backgroundColor: 'white',
        borderRadius: '12px',
        boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
        marginTop: '80px',
    },

    title: {
        marginBottom: '16px',
        color: '#333',
        fontWeight: 'bold',
    },
    message: {
        marginBottom: '24px',
        color: '#666',
        lineHeight: 1.6,
    },
    buttonContainer: {
        display: 'flex',
        flexDirection: 'column',
        gap: '12px',
        width: '100%',
    },
    retryButton: {
        backgroundColor: '#4CAF50',
        color: 'white',
        padding: '12px 24px',
        '&:hover': {
            backgroundColor: '#45a049',
        },
        '&:disabled': {
            backgroundColor: '#cccccc',
            color: '#666666',
        },
    },

    statusText: {
        marginTop: '16px',
        fontSize: '14px',
        color: '#888',
    },
    loadingContainer: {
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
    },
}));

export default (props) => {
    const classes = useStyles();
    const [isRetrying, setIsRetrying] = useState(false);
    const [lastChecked, setLastChecked] = useState(null);
    const [autoRetryCount, setAutoRetryCount] = useState(0);

    // Auto-retry every 30 seconds (max 5 times)
    useEffect(() => {
        if (autoRetryCount < 5) {
            const timer = setTimeout(() => {
                handleRetry(true);
            }, 30000);

            return () => clearTimeout(timer);
        }
    }, [autoRetryCount]);

    const handleRetry = async (isAutoRetry = false) => {
        if (isRetrying) return;
        
        setIsRetrying(true);
        setLastChecked(new Date());
        
        if (isAutoRetry) {
            setAutoRetryCount(prev => prev + 1);
        } else {
            setAutoRetryCount(0); // Reset auto-retry count on manual retry
        }

        try {
            // Reload the page to retry the connection
            setTimeout(() => {
                window.location.reload();
            }, 1000);
        } catch (error) {
            console.error('Retry failed:', error);
            setIsRetrying(false);
        }
    };



    const formatTime = (date) => {
        return date ? date.toLocaleTimeString('zh-TW', { 
            hour: '2-digit', 
            minute: '2-digit',
            second: '2-digit'
        }) : '';
    };

    return (
        <div>
            <div className={classes.topPanel}>
                <Typography variant='h3'>
                    ALL DAY
                </Typography>
            </div>
            <div className={classes.root}>
                <div className={classes.content}>
                    <Typography variant="h5" className={classes.title}>
                        {props.title || '餐廳暫時離線'}
                    </Typography>
                    
                    <Typography variant="body1" className={classes.message}>
                        餐廳系統目前離線中，可能是網路連線問題或系統維護。
                        <br />
                        請稍後再試或聯繫餐廳服務人員。
                    </Typography>

                    <div className={classes.buttonContainer}>
                        <Button
                            variant="contained"
                            className={classes.retryButton}
                            onClick={() => handleRetry(false)}
                            disabled={isRetrying}
                            startIcon={isRetrying ? <CircularProgress size={20} color="inherit" /> : <RefreshIcon />}
                        >
                            {isRetrying ? (
                                <div className={classes.loadingContainer}>
                                    重新連線中...
                                </div>
                            ) : (
                                '重新嘗試'
                            )}
                        </Button>
                    </div>

                    {lastChecked && (
                        <Typography variant="caption" className={classes.statusText}>
                            最後檢查時間: {formatTime(lastChecked)}
                            {autoRetryCount > 0 && ` (自動重試 ${autoRetryCount}/5)`}
                        </Typography>
                    )}

                    {autoRetryCount >= 5 && (
                        <Typography variant="caption" className={classes.statusText} style={{ color: '#ff6b6b' }}>
                            已停止自動重試，請手動重新嘗試
                        </Typography>
                    )}
                </div>
            </div>
        </div>
    );
};
